/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2026-06-20 18:56:55
 * @LastEditTime: 2026-06-20 19:36:08
 * @Description: 
 */
type TranslationDictionary = Record<string, string>;

type TranslationModule = {
  default?: TranslationDictionary;
  common?: TranslationDictionary;
};

type I18nResources = Record<string, { translation: TranslationDictionary }>;

const modules = import.meta.glob('./*/*.ts', { eager: true }) as Record<string, TranslationModule>;

const messages: I18nResources = {};

Object.entries(modules).forEach(([path, module]) => {
  const match = path.match(/\.\/([^/]+)\/[^/]+\.ts$/);
  if (!match) return;

  const [, lang] = match;
  const translations = module.default || module.common;
  if (!translations) return;

  if (!messages[lang]) {
    messages[lang] = { translation: {} };
  }

  messages[lang].translation = {
    ...messages[lang].translation,
    ...translations,
  };
});

export default messages;
